export const CACHE_MAP = {};

export const downloadAndCache = async (url) => {
  if (url in CACHE_MAP) {
    return;
  }

  CACHE_MAP[url] = null;
  const response = await fetch(url);
  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);
  CACHE_MAP[url] = blobUrl;
};
